module.exports = __webpack_public_path__ + "img/2.3482cc43.jpg";